import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../../../../service";
import {IErrorResponse, IRootState} from "../../../../../../../types";
import {setLoadCoefficients, updateCoefficients} from "./loadCoefficientsSlice";
import { ILoadCoefficientsPayload} from "../types";




const GetLoadCoefficients= createAsyncThunk(
    "get/load/coefficients",
    async (_, { dispatch, rejectWithValue,getState }) => {
        try {
            const response = await request.get("/calculation-options");
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setLoadCoefficients({ data: response.data,defaultLanguage }));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const EditLoadCoefficient = createAsyncThunk(
    "edit/load/coefficients",
    async ( data : ILoadCoefficientsPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/calculation-options/update/${data.id}`, data);
            dispatch(updateCoefficients(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


export{
    GetLoadCoefficients,
    EditLoadCoefficient
}